export default {
  // Properties panel translation.
  General: "General",
  Variables: "Variables",
  Connector: "Conector",
  Forms: "Formularios",
  Listeners: "Oyentes",
  "Input/Output": "Entrada / Salida",
  Extensions: "Extensiones",
  "camunda-id": "Id",
  Name: "Nombre",
  "Element Template": "Plantilla de elemento",
  Implementation: "Implementación",
  "Version Tag": "Etiqueta de versión",
  Executable: "Ejecutable",
  "Result Variable": "Variable de resultado",
  Topic: "Tema",
  "Task Priority": "Prioridad de tarea",
  "Asynchronous Before": "Asíncrono",
  "Asynchronous After": "Después de asíncrono",
  Exclusive: "Exclusivo",
  "Job Priority": "Prioridad laboral",
  "Element Documentation": "Documentación de elemento",
  "Connector Id": "Id. De conector",
  "Input Parameters": "Parámetros de entrada",
  "Output Parameters": "Parámetros de salida",
  "camunda-connector-parameterName": "Nombre",
  Type: "Me gusta",
  Value: "Valor",
  "Script Format": "Formato de script",
  "Script Type": "Tipo de script",
  Resource: "Recurso",
  Script: "Script",
  "Event Type": "Tipo de evento",
  "Listener Type": "Tipo de escucha",
  "Parameter must have a name": "El parámetro debe tener un nombre",
  "Must provide a value": "Debe proporcionar un valor",
  Text: "Texto",
  List: "Lista",
  Map: "Mapa",
  "Inline Script": "Script incrustado",
  "External Resource": "Recurso externo",
  start: "inicio",
  end: "fin",
  "Java Class": "Clase Java",
  Expression: "Expresión",
  "Delegate Expression": "Expresión delegada",
  External: "Externo",
  "Add Execution Listener": "Agregar escucha de ejecución",
  "cam-extensionElements-inputs": "Parámetros de entrada",
  "cam-extensionElements-outputs": "Parámetros de salida",
  "camunda-parameterName": "Nombre",
  "camunda-parameterType": "Tipo",
  "camunda-parameterType-text": "Valor",
  Initiator: "Iniciador",
  "Form Type": "Tipo de formulario",
  "Form Key": "Clave de formulario",
  "Form Keys": "Claves de formularios",
  "Model type": "Tipo de plantilla",
  State: "Estado",
  "Schema type": "Tipo de esquema",
  "Schema name": "Nombre del esquema",
  Comment: "Comentario",
  "Script language": "Lenguaje de script",
  "Process type": "Tipo de proceso",
  "Model name": "Nombre de plantilla",
  "Custom Fields": "Campos personalizados",
  Details: "Detalles",
  "External Task Configuration": "Configuración de tareas externas",
  "Multi Instance": "Múltiples instancias",
  "Asynchronous Continuations": "Continuaciones asincrónicas",
  "Job Configuration": "Configuración de trabajo",
  Documentation: "Documentación",
  //'input/output' : 'Entrada / Salida',
  "Execution Listeners": "Ejecutores oyentes",
  "Execution Listener": "Escucha de ejecución",
  "Task Listeners": "Oyentes de tareas",
  Parameters: "Parámetros",
  Properties: "Propiedades",
  "Input Parameter": "Parámetro de entrada",
  "Add Value": "Agregar valor",
  "Add Entry": "Agregar entrada",
  "Add Property": "Agregar propiedad",
  "Candidate Starter Configuration": "Configuración de candidato principiante",
  "Candidate Starter Groups": "Grupos candidatos",
  "Candidate Starter Users": "Usuarios candidatos",
  "History Configuration": "Configuración del historial",
  "History Time To Live": "Hora del cuento",
  "Tasklist Configuration": "Configuración de la lista de tareas",
  Startable: "Iniciable",
  "Field Injection": "Inyección de campo",
  Fields: "Campos",
  "Open minimap": "Minimapa abierta",
  "Form Fields": "Campos de formulario",
  "Form Field": "Campo de formulario",
  "Business Key": "Clave comercial",
  Label: "Etiqueta",
  "Default Value": "Valor predeterminado",
  Validation: "Validación",
  "Add Constraint": "Agregar restricción",
  "Properties Smart": "Propiedades inteligentes",
  "Field properties": "Propiedades de campo",
  "Smart Types": "Tipos inteligentes",
  //'name' : 'Name',

  // Labels
  "This maps to the process definition key.":
    "Esto se asigna a la clave de definición de proceso",
  "Specify more than one group as a comma separated list.":
    "Especifique más de un grupo como una lista separada por comas",
  "Specify more than one user as a comma separated list.":
    "Especifique más de un usuario como una lista separada por comas",
  "Activate the global connect tool":
    "Habilitar herramienta de conexión global",
  "Append {type}": "Adjuntar {tipo}",
  "Add Lane above": "Agregar vía arriba",
  "Divide into two Lanes": "Dividir de dos maneras",
  "Divide into three Lanes": "Divide de tres maneras",
  "Add Lane below": "Agregar vía abajo",
  "Append compensation activity": "Adjuntar actividad de compensación",
  "Append Intermediate/Boundary Event": "Adjuntar evento intermedio / umbral",
  "Append Gateway": "Adjuntar puerta de enlace",
  "Change type": "Cambiar tipo",
  "Connect using Association": "Conectar usando asociación",
  "Connect using Sequence/MessageFlow or Association":
    "Conectar usando secuencia / flujo de mensajes o asociación",
  "Connect using DataInputAssociation":
    "Conectar usando la entrada de datos de unión",
  Remove: "Eliminar",
  "Activate the hand tool": "Herramienta manual de corbata",
  "Activate the lasso tool": "Habilitar herramienta de lazo",
  "Activate the create/remove space tool":
    "Habilitar agregar / quitar herramienta de espacio",
  "Create expanded SubProcess": "Crear subproceso expandido",
  "Create IntermediateThrowEvent/BoundaryEvent":
    "Crear intermedioThrowEvent / BoundaryEvent",
  "Create Intermediate/Boundary Event": "Crear evento intermedio / límite",
  "Create Pool/Participant": "Crear grupo / participante",
  "Create Start Timer Event": "Crear evento de inicio de hora",
  "Create Gateway": "Crear puerta de enlace",
  "Parallel Multi Instance": "Instancia paralela múltiple",
  "Sequential Multi Instance": "Instancia multisecuencial",
  Loop: "Bucle",
  "Ad-hoc": "Ad-hoc",
  "Create {type}": "Crear {tipo}",
  Task: "Tarea",
  "Send Task": "Enviar trabajo",
  "Receive Task": "Eliminar tarea",
  "User Task": "Tarea de usuario",
  "Manual Task": "Tarea manual",
  "Business Rule Task": "Tarea de reglas de negocio",
  "Service Task": "Tarea de tipo de servicio",
  "Script Task": "Tarea de script",
  "Call Activity": "Actividad de llamada",
  "Sub Process (collapsed)": "Subproceso (agrupado)",
  "Start Event": "Iniciar evento",
  "Intermediate Throw Event": "Evento de lanzamiento intermedio",
  "End Event": "Evento final",
  "Message Start Event": "Evento de inicio de mensaje",
  "Timer Start Event": "Evento de inicio del temporizador",
  "Conditional Start Event": "Evento de inicio condicional",
  "Signal Start Event": "Evento de inicio de señal",
  "Error Start Event": "Evento de inicio de error",
  "Escalation Start Event": "Evento de escalada inicial",
  "Compensation Start Event": "Evento de inicio de compensación",
  "Message Start Event (non-interrupting)":
    "Evento de inicio de mensaje (sin parar)",
  "Timer Start Event (non-interrupting)":
    "Evento de inicio del temporizador (sin parar)",
  "Conditional Start Event (non-interrupting)":
    "Evento de inicio condicional (ininterrumpido)",
  "Signal Start Event (non-interrupting)":
    "Evento de inicio de señal (ininterrumpido)",
  "Escalation Start Event (non-interrupting)":
    "Evento de escalamiento inicial (ininterrumpido)",
  "Message Intermediate Catch Event": "Capturar mensaje intermedio de evento",
  "Message Intermediate Throw Event":
    "Mensaje de evento de lanzamiento intermedio",
  "Timer Intermediate Catch Event":
    "Evento de captura intermedia del temporizador",
  "Escalation Intermediate Throw Event":
    "Evento de lanzamiento intermedio de escalada",
  "Conditional Intermediate Catch Event":
    "Evento de captura intermedia condicional",
  "Link Intermediate Catch Event": "Enlace de evento de captura intermedia",
  "Link Intermediate Throw Event": "Enlace de evento de lanzamiento intermedio",
  "Compensation Intermediate Throw Event": "Evento de compensación intermedia",
  "Signal Intermediate Catch Event": "Evento de error intermedio",
  "Signal Intermediate Throw Event": "Evento de lanzamiento intermedio",
  "Message End Event": "Evento de fin de mensaje",
  "Escalation End Event": "Evento de escalada final",
  "Error End Event": "Evento de error final",
  "Cancel End Event": "Cancelar evento final",
  "Compensation End Event": "Fin del evento de compensación",
  "Signal End Event": "Evento de señal final",
  "Terminate End Event": "Finalizar evento final",
  "Message Boundary Event": "Evento de mensaje de borde",
  "Message Boundary Event (non-interrupting)":
    "Evento de mensaje de borde (ininterrumpido)",
  "Timer Boundary Event": "Evento de límite de temporizador",
  "Timer Boundary Event (non-interrupting)":
    "Evento de límite de temporizador (ininterrumpido)",
  "Escalation Boundary Event": "Evento de límite de escalamiento",
  "Escalation Boundary Event (non-interrupting)":
    "Evento de límite de escalamiento (ininterrumpido)",
  "Conditional Boundary Event": "Evento límite condicional",
  "Conditional Boundary Event (non-interrupting)":
    "Evento límite condicional (ininterrumpido)",
  "Error Boundary Event": "Evento de límite de error",
  "Cancel Boundary Event": "Cancelar evento de umbral",
  "Signal Boundary Event": "Evento de límite de señal",
  "Signal Boundary Event (non-interrupting)":
    "Evento de límite de señal (ininterrumpido)",
  "Compensation Boundary Event": "Evento de límite de compensación",
  "Exclusive Gateway": "Gateway exclusivo",
  "Parallel Gateway": "Puerta de enlace paralela",
  "Inclusive Gateway": "Portal inclusivo",
  "Complex Gateway": "Complejo de puerta de enlace",
  "Event based Gateway": "Puerta de enlace basada en eventos",
  Transaction: "Transacción",
  "Sub Process": "Subproceso",
  "Event Sub Process": "Evento de subproceso",
  "Collapsed Pool": "Piscina cerrada",
  "Expanded Pool": "Piscina ampliada",

  // Errors
  "no parent for {element} in {parent}":
    "sin elemento primario para {element} en {parent}",
  "no shape type specified": "tipo de forma no especificada",
  "flow elements must be children of pools/participants":
    "los elementos de flujo deben ser hijos de grupos / participantes",
  "out of bounds release": "liberar límites",
  "more than {count} child lanes": "más de {count} pistas secundarias",
  "element required": "elemento requerido",
  "diagram not part of bpmn:Definitions":
    "el diagrama no cumple bpmn: definiciones",
  "no diagram to display": "no hay diagrama para mostrar",
  "no process or collaboration to display":
    "no hay procesos o colaboración para mostrar",
  "element {element} referenced by {referenced}#{property} not yet drawn":
    "elemento {element} al que hace referencia {referenced}#{property} no está listo para dibujar",
  "already rendered {element}": "{element} ya renderizado",
  "failed to import {element}": "no se pudo importar {element}",

  //itens smart
  "Read Only": "Solo lectura",
  "Sets a value indicating whether this element is enabled in the user interface.":
    "Establecer un valor que indique si este elemento está habilitado en la interfaz de usuario",
  Tooltip: "Consejo",
  "Sets a tooltip message that is displayed for this element in the user interface.":
    "Define un mensaje de información sobre herramientas que se muestra para este elemento en la interfaz de usuario",
  "Regular Expression": "Expresión regular",
  "Sets a regex validation that will apply before submitting the form.":
    "Establezca una validación de expresiones regulares que se aplicará antes de enviar el formulario",
  "Regex Message": "Mensaje de expresiones regulares",
  "Sets a regex error message that is displayed for this element in the user interface.":
    "Define un mensaje de error regex que se muestra para este elemento en la interfaz de usuario",
  Required: "Requerido",
  "Sets that an input field must be filled out before submitting the form. Show a defined message when is not filled.":
    "Define que se debe completar un campo de entrada antes de enviar el formulario. Mostrar un mensaje definido cuando no está lleno. ",
  "Show Field": "Mostrar campo",
  "Defines that indicates whether this element will be visible in the Task List.":
    "Define que indica si este elemento será visible en la lista de tareas",
  "OnBlur API": "API OnBlur",
  "Defines that this element will go to receive custom information from a web API. Must provide a URL path.":
    "Define que este elemento recibirá información personalizada de una API web. Debe proporcionar una ruta URL. ",
  "Multi Line": "Línea múltiple",
  "Defines a multi-line text input control.":
    "Define un control de entrada de texto multilínea",
  Rows: "Líneas",
  "Sets the maximum number of visible lines to size to.":
    "Establece el número máximo de líneas visibles para el tamaño",
  "Supplemental info": "Información complementaria",
  "Displays supplemental information in the user interface.":
    "Muestra información complementaria en la interfaz de usuario",
  History: "Historia",
  "Displays a history in the user interface.":
    "Mostrar un historial en la interfaz de usuario",
  Upload: "Subir",
  "Premite o upload de documentos": "Permitir subir documentos",
  "Accepted Files": "Archivos aceptados",
  "Defines the types of documents allowed on upload.":
    "Define los tipos de documentos permitidos en la carga",
  "Documents Types": "Tipos de documentos",
  "Read Only (Document Type)": "Solo lectura (Tipos de Documento)",
  "Sets a web APi URL that returns the documents types that will be list in the user interface.":
    "Define una URL APi web que devuelve los tipos de documentos que se enumerarán en la interfaz de usuario",
  "Sets the documents types list is enabled in the user interface.":
    "Define que la lista de tipos de documentos está habilitada en la interfaz de usuario",
  "Technical Advice": "Opinion tecnica",
  "Read Only (Technical Advice)": "Solo lectura (Opinion tecnica)",
  "Sets a web APi URL that returns the Technical Advice that will be list in the user interface.":
    "Define una URL APi web que devuelve los consejos técnicos que se enumerarán en la interfaz de usuario",
  "Sets the Technical Advice list is enabled in the user interface.":
    "Define que la lista de consejos está habilitada en la interfaz de usuario",
  Content: "Contenido",
  "Sets the custom user interface.":
    "Define la interfaz de usuario personalizada",
  "Generated Forms fields": "Campos de formulario generados",
  Copy: "Copia",
  Cancel: "Cancelar",
  imageViewer: "Visualización de imágenes",
  "Sets the Image Viewer is enabled in the user interface.":
    "Define que Image Viewer está habilitado en la interfaz de usuario.",
  "Thousand Separator": "Mil separadores",
  "Add thousand separators on number": "Agregar mil separadores al número",
  "Decimal Separator": "Separador decimal",
  "Support decimal point on a number": "Suporte a número decimal",
  "Decimal Scale": "Escala decimal",
  "If defined it limits to given decimal scale":
    "Define qual o limite de escala decimal",
  "Allow Negative": "Permite negativo",
  "Alow negative numbers": "Permite números negativos",
  "Signature required": "Firma requerida",
  "Sets that an PDF file must be signature out before submitting the form. Show a defined message when is not filled.":
    "Establece que un archivo PDF debe estar firmado antes de enviar el formulario. Mostrar un mensaje definido cuando no está lleno.",
  "Signature task required": "Tarea de firma requerida",
  "Sets that an task must be signature out before submitting the form. Show a defined message when is not filled.":
    "Establece que una tarea debe estar firmada antes de enviar el formulario. Mostrar un mensaje definido cuando no está lleno.",
  Assignee: "Cesionario",
  assignee: "cesionario",
  "Candidate Users": "Usuarios candidatos",
  "Candidate Groups": "Grupos de candidatos",
  "Due Date": "Fecha de vencimiento",
  // eslint-disable-next-line no-template-curly-in-string
  "The due date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)":
    "La fecha de vencimiento como una expresión EL (por ejemplo, $ {someDate} o una fecha ISO (por ejemplo, 2015-06-26T09: 54: 00)", // eslint-disable-line no-template-curly-in-string
  "Follow Up Date": "Fecha de seguimiento",
  // eslint-disable-next-line no-template-curly-in-string
  "The follow up date as an EL expression (e.g. ${someDate} or an ISO date (e.g. 2015-06-26T09:54:00)":
    "La fecha de seguimiento como una expresión EL (por ejemplo, $ {someDate} o una fecha ISO (por ejemplo, 2015-06-26T09: 54: 00)", // eslint-disable-line no-template-curly-in-string
  Priority: "Prioridad",
  "This maps to the task definition key.":
    "Esto se asigna a la clave de definición de tarea.",
  "Output Parameter": "Parámetro de salida",
  Message: "Mensaje",
  "Message Name": "Nombre del mensaje",
  "Timer Definition Type": "Tipo de definición de temporizador",
  Date: "Fecha",
  Duration: "Duración",
  Cycle: "Ciclo",
  "Timer Definition": "Definición del temporizador",
  "Retry Time Cycle": "Reintentar ciclo de tiempo",
  "Variable Name": "Nombre de la variable",
  "Condition Type": "Tipo de condición",
  Signal: "Señal",
  "Signal Name": "Nombre de señal",
  Escalation: "Escalada",
  "Escalation Name": "Nombre de escalamiento",
  "Escalation Code": "Código de escalamiento",
  "Escalation Code Variable": "Variable de código de escalamiento",
  "Variable Event": "Evento variable",
  "Specify more than one variable change event as a comma separated list.":
    "Especifique más de un evento de cambio variable como una lista separada por comas.",
  "Link Name": "Nombre del enlace",
  "Wait for Completion": "Espera a la finalización",
  "Activity Ref": "Referencia de actividad",
  "Append TimerIntermediateCatchEvent": "Agregar TimerIntermediateCatchEvent",
  "Append MessageIntermediateCatchEvent":
    "Añadir mensajeIntermediateCatchEvent",
  "Append ConditionIntermediateCatchEvent":
    "Añadir condiciónIntermediaCatchEvent",
  "Append SignalIntermediateCatchEvent": "Anexar SignalIntermediateCatchEvent",
  TextAnnotation: "TextAnnotation",
  "Set Color": "Establecer color",
  Red: "Rojo",
  Orange: "Naranja",
  Yellow: "Amarillo",
  Green: "Verde",
  Blue: "Azul",
  Indigo: "Índigo",
  Violet: "Violeta",
  "Must configure Connector": "Debe configurar el conector",
  "Decision Ref": "Decisión Ref",
  Binding: "Unión",
  latest: "último",
  deployment: "despliegue",
  version: "versión",
  Version: "Versión",
  versionTag: "versionTag",
  "Tenant Id": "Identificación del inquilino",
  "CallActivity Type": "Tipo de actividad de llamada",
  "Called Element": "Elemento llamado",
  "Delegate Variable Mapping": "Delegar asignación de variables",
  "In Mapping": "En mapeo",
  "Out Mapping": "Out Mapping",
  Source: "Fuente",
  "Source Expression": "Expresión de origen",
  "Mapping must have a {value}": "La asignación debe tener un {valor}",
  "Mapping must have a value": "El mapeo debe tener un valor",
  Target: "Objetivo",
  "Mapping must have a target": "El mapeo debe tener un objetivo",
  "Target must not contain whitespace":
    "El objetivo no debe contener espacios en blanco",
  Class: "Clase",
  "Process Name": "Nombre del proceso",
  "Process Id": "Identificacion de proceso",
  "Process Documentation": "Documentación de proceso",
  variableMappingClass: "variableMappingClass",
  variableMappingDelegateExpression: "variableMappingDelegateExpression",
  "{label} must not contain whitespace":
    "{label} no debe contener espacios en blanco",
  All: "Todos",
  Error: "Error",
  "Error Name": "Nombre de error",
  "Error Code": "Código de error",
  "Error Message": "Mensaje de error",
  "Error Code Variable": "Variable de código de error",
  "Error Message Variable": "Variable de mensaje de error",
  "Category Value": "Valor de categoría",
  "Task Listener": "Escucha de tareas",
  "Field Injections": "Inyecciones de campo",
  "[unknown template: {templateId}]": "[plantilla desconocida: {templateId}]",
  "Custom Fields for scope: ": "Campos personalizados para el alcance:",
  "Must not be empty": "No debe estar vacío",
  "Must have max length {length}": "Debe tener una longitud máxima {longitud}",
  "Must have min length {length}": "Debe tener una longitud mínima {longitud}",
  "Must match pattern {pattern}": "Debe coincidir con el patrón {patrón}",
  Condition: "Condición",
  Config: "Config",
  Values: "Valores",
  "Case Ref": "Caso Ref",
  "Business Key Expression": "Expresión clave empresarial",
  "Map Decision Result": "Resultado de la decisión del mapa",
  "Name must not contain spaces": "El nombre no debe contener espacios",
  "Must provide either loop cardinality or collection":
    "Debe proporcionar cardinalidad o colección de bucles",
  "Loop Cardinality": "Cardinalidad de bucle",
  Collection: "Colección",
  "Element Variable": "Elemento variable",
  "Completion Condition": "Condición de finalización",
  take: "tomar",
  create: "crear",
  assignment: "asignación",
  complete: "completar",
  delete: "Eliminar",
  "Multi Instance ": "Instancia múltiple",
  "Configure Connector": "Configurar conector",
  "Element must have an unique id.":
    "El elemento debe tener una identificación única.",
  "Id must not contain spaces.": "La identificación no debe contener espacios.",
  "Id must not contain prefix.": "Id no debe contener prefijo.",
  "Id must be a valid QName.": "Id debe ser un QName válido.",
  "Config SmartRules": "Configura smartRules",
  Category: "Categoría",
  Description: "Descripción",
  "Available process variables, identified in the diagram.":
    "Variables de proceso disponibles, identificadas en el diagrama.",
  "No variables found.": "No se encontraron variables.",
  Edit: "Editar",
  "Add Form": "Añadir formulario",
  Delete: "Eliminar",
  Signature: "Firma",
  "Documents for signature": "Documentos para firmar",
  "External Portal": "Portal Externo",
  "Automatic Process": "Proceso automático"
};
